module.exports = __webpack_public_path__ + "static/media/document-hand-held-writing-active.cbf0338d.svg";